var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGallery28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 9.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C6.04 3 7.16 3 9.4 3h9.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C25 6.04 25 7.16 25 9.4v9.853c0 1.82 0 2.73-.386 3.543a4.29 4.29 0 0 1-1.565 1.722c-.773.46-1.597.54-3.244.696A61.717 61.717 0 0 1 14 25.5c-2.118 0-4.112-.125-5.805-.286-1.647-.157-2.47-.235-3.244-.696a4.29 4.29 0 0 1-1.565-1.722C3 21.982 3 21.073 3 19.253V9.4Zm6.815 4.591-.994 1.175c-.87 1.028-1.305 1.543-1.685 1.595a1 1 0 0 1-.88-.323C6 16.153 6 15.48 6 14.132V9.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C7.52 6 8.08 6 9.2 6h9.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 7.52 22 8.08 22 9.2v5.268c0 .962 0 1.443-.128 1.67a1 1 0 0 1-1.247.438c-.243-.098-.543-.474-1.144-1.225l-.316-.394c-.108-.136-.163-.204-.212-.256a1.5 1.5 0 0 0-2.032-.112c-.056.045-.117.107-.24.23a3.777 3.777 0 0 1-.219.21 1.5 1.5 0 0 1-1.924 0 3.777 3.777 0 0 1-.219-.21l-.975-.975c-.64-.64-.96-.96-1.324-1.068a1.5 1.5 0 0 0-.974.04c-.354.138-.646.484-1.23 1.175ZM18 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery28);
export default __webpack_public_path__ + "static/media/gallery_28.aec3791d.svg";
export { ForwardRef as ReactComponent };